/* ArabEsq brand behaviors — idempotent; safe to include from multiple sections */
(function () {
  if (window.__arbInit) return;
  window.__arbInit = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var countdowns = document.querySelectorAll("[data-arb-countdown]");
    if (countdowns.length) {
      var tick = function () {
        countdowns.forEach(function (el) {
          var end = new Date(el.getAttribute("data-arb-countdown"));
          var d = Math.max(0, end - new Date());
          var days = Math.floor(d / 86400000),
            hrs = Math.floor((d % 86400000) / 3600000),
            min = Math.floor((d % 3600000) / 60000),
            sec = Math.floor((d % 60000) / 1000);
          var set = function (sel, v) {
            var n = el.querySelector(sel);
            if (n) n.textContent = v;
          };
          set(".arb-cd-d", days);
          set(".arb-cd-h", String(hrs).padStart(2, "0"));
          set(".arb-cd-m", String(min).padStart(2, "0"));
          set(".arb-cd-s", String(sec).padStart(2, "0"));
        });
      };
      tick();
      setInterval(tick, 1000);
    }

    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".arb-reveal").forEach(function (el) {
      io.observe(el);
    });

    document.querySelectorAll("[data-arb-flow]").forEach(function (flow) {
      var cards = Array.prototype.slice.call(flow.querySelectorAll(".arb-fcard"));
      if (!cards.length) return;
      var center = 0;
      function layout() {
        cards.forEach(function (el, i) {
          var off = i - center;
          var half = cards.length / 2;
          if (off > half) off -= cards.length;
          if (off < -half) off += cards.length;
          var abs = Math.abs(off);
          el.style.transform =
            "translateX(" + off * 240 + "px) translateZ(" + -abs * 150 + "px) rotateY(" + off * -22 + "deg)";
          el.style.opacity = abs > 2.5 ? 0 : 1 - abs * 0.16;
          el.style.zIndex = 100 - Math.round(abs * 10);
          el.style.filter = abs < 0.5 ? "none" : "saturate(.85)";
          el.style.pointerEvents = abs > 2.5 ? "none" : "auto";
        });
      }
      function step(dir) {
        center = (center + dir + cards.length) % cards.length;
        layout();
      }
      layout();
      var root = flow.closest("[data-arb-flow-root]") || document;
      var next = root.querySelector("[data-arb-flow-next]");
      var prev = root.querySelector("[data-arb-flow-prev]");
      if (next) next.addEventListener("click", function () { step(1); });
      if (prev) prev.addEventListener("click", function () { step(-1); });
      cards.forEach(function (el, i) {
        el.addEventListener("click", function (e) {
          if (e.target.closest(".add") || e.target.closest("a")) return;
          if (i !== center) {
            center = i;
            layout();
          }
        });
      });
      var auto = setInterval(function () { step(1); }, 3400);
      flow.addEventListener("mouseenter", function () { clearInterval(auto); });
      flow.addEventListener("mouseleave", function () {
        auto = setInterval(function () { step(1); }, 3400);
      });
    });

    document.querySelectorAll(".arb-tilt").forEach(function (card) {
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5,
          y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          "rotateY(" + x * 12 + "deg) rotateX(" + y * -10 + "deg) translateY(-4px)";
        card.style.setProperty("--gx", (x + 0.5) * 100 + "%");
        card.style.setProperty("--gy", (y + 0.5) * 100 + "%");
      });
      card.addEventListener("mouseleave", function () {
        card.style.transform = "";
      });
    });

    document.querySelectorAll("[data-arb-tabs]").forEach(function (tabs) {
      var root = tabs.closest("[data-arb-tabs-root]") || document;
      tabs.querySelectorAll("button[data-pane]").forEach(function (b) {
        b.addEventListener("click", function () {
          tabs.querySelectorAll("button").forEach(function (x) { x.classList.remove("on"); });
          root.querySelectorAll(".arb-pane").forEach(function (p) { p.classList.remove("on"); });
          b.classList.add("on");
          var pane = root.querySelector('[data-pane-id="' + b.getAttribute("data-pane") + '"]');
          if (pane) pane.classList.add("on");
        });
      });
    });

    document.querySelectorAll(".arb-flip").forEach(function (f) {
      f.addEventListener("click", function () { f.classList.toggle("flipped"); });
    });

    function refreshCartUI() {
      var drawer = document.querySelector("cart-drawer");
      var bubble = document.getElementById("cart-icon-bubble");
      var sections = [];
      if (drawer) sections.push("cart-drawer");
      if (bubble) sections.push("cart-icon-bubble");
      if (!sections.length) {
        window.location.href = "/cart";
        return;
      }
      fetch("/?sections=" + sections.join(","))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data["cart-icon-bubble"] && bubble) {
            var tmp = document.createElement("div");
            tmp.innerHTML = data["cart-icon-bubble"];
            var inner = tmp.querySelector("#cart-icon-bubble") || tmp;
            bubble.innerHTML = inner.innerHTML;
          }
          if (data["cart-drawer"] && drawer) {
            var t2 = document.createElement("div");
            t2.innerHTML = data["cart-drawer"];
            var nd = t2.querySelector("cart-drawer");
            if (nd) {
              drawer.innerHTML = nd.innerHTML;
              drawer.classList.remove("is-empty");
            }
            if (typeof drawer.open === "function") drawer.open();
          }
        })
        .catch(function () {
          window.location.href = "/cart";
        });
    }

    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-arb-add]");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute("data-arb-add");
      if (!variantId) return;
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () {
          btn.textContent = "Added ✓";
          refreshCartUI();
          setTimeout(function () {
            btn.textContent = orig;
            btn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          btn.textContent = orig;
          btn.disabled = false;
          window.location.href = "/cart";
        });
    });
  });
})();
